import { Component, OnInit } from "@angular/core";
import { TestScheduleService } from "src/app/shared";
import { Router } from "@angular/router";
import { AlertService } from "../../../shared/services/alert/alert.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-test-schedule",
  templateUrl: "./test-schedule.component.html",
  styleUrls: ["./test-schedule.component.scss"]
})
export class TestScheduleComponent implements OnInit {
  fileType: any =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataCount: any;
  uploadType: any = "import";
  error: any;
  testschedule: any;
  sender = "upload-test-schedule";
  errorOnly = false;
  errorCount = 0;
  showAll = true;
  onlyError = false;

  constructor(
    private router: Router,
    private testScheduleService: TestScheduleService,
    private alertService: AlertService
  ) {}

  ngOnInit() {}

  ondocImport(e) {
    this.testschedule = e;
    console.log ("doc inmport ==--", e);

    if (this.testschedule.status == "error"){
      this.error = this.testschedule.error;
      this.alertService.err (this.sender, this.error);
      return;
    }

    this.errorCount = 0
    var rows = this.testschedule.rows || [];
    this.dataCount = rows.length;

    for (var i=0; i<rows.length; i++){
      if (rows[i].errors.length >0){
        this.errorCount += 1;
        
      }
    }

    if (this.errorCount >0){
      this.alertService.err (this.sender, "Found " + this.errorCount + " errors");
    }

  }

  onConfirm() {
    if (!this.testschedule){

      this.alertService.err (this.sender, "No data found");
      return;
    }

    if (!this.testschedule.rows){
      this.alertService.err (this.sender, "No rows found");
      return;
    }
    
    if (this.testschedule.rows.length == 0){
      this.alertService.err (this.sender, "No data rows found");
      return;
    }

    if (this.errorCount > 0){
      this.alertService.err (this.sender, "There are errors in this file");
      return;
    }
 
    this.testScheduleService
      .saveImportTestSchedules(this.testschedule.docRes)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "Test Schedule Data Saved");
        this.router.navigate(["manager/upload-test-schedule"]);
      });
  }

  ondocError(e) {
   // console.log("doc error .....", e);
    this.error = e;
  }

  filterRows (rows){
    //console.log ("filtersig ...", this.onlyError);
     if (!this.onlyError){
       return rows;
     }
    // console.log ("filetring for erorrs");
     var errs =  rows.filter (x => x.errors.length >0);
    // console.log("got these rrrorss", errs);

     return errs;
  }
}
